import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

/** Compact per-phase effort/duration bars (used in the results sidebar). */
export function PhaseTimeline({ phases }) {
  const { t } = useTranslation();
  return (
    <Card className="bg-white border-[#DDE1E5] shadow-sm">
      <CardHeader className="pb-2">
        <CardTitle className="text-sm text-[#66707A] uppercase tracking-wider">
          {t('results.projectPhases')}
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-3" data-testid="phase-timeline">
        {phases.map((phase) => (
          <div key={phase.id}>
            <div className="flex flex-wrap justify-between gap-2 text-xs mb-1">
              <span className="text-[#171A1D]">{t('calcData.phases.' + phase.id)}</span>
              <span className="text-[#8A929B]" style={{ fontFamily: 'IBM Plex Mono, monospace' }}>
                {phase.effort} {t('estimates.days')} / {phase.durationWeeks} {t('estimates.weeks')}
              </span>
            </div>
            <div className="h-1.5 w-full bg-[#F5F6F7] rounded-sm overflow-hidden" aria-hidden="true">
              <div className="h-full bg-[#3A4249]" style={{ width: `${phase.percentOfEffort * 3}%` }} />
            </div>
          </div>
        ))}
      </CardContent>
    </Card>
  );
}
